import { SVGProps } from 'react';

interface LogoProps extends SVGProps<SVGSVGElement> {
    color?: string;
}

const Logo = ({ color = 'currentColor', ...props }: LogoProps) => {
    return (
        <svg
            version="1.0"
            xmlns="http://www.w3.org/2000/svg"
            width="605.000000pt"
            height="107.000000pt"
            viewBox="0 0 605.000000 107.000000"
            preserveAspectRatio="xMidYMid meet"
            {...props}
        >
            <g
                transform="translate(0.000000,107.000000) scale(0.100000,-0.100000)"
                fill={color}
                stroke="none"
            >
                <path
                    d="M1263 1005 c-311 -68 -477 -408 -337 -693 60 -122 158 -206 294 -252
       54 -18 82 -21 166 -18 95 3 106 6 186 46 177 87 278 246 278 438 0 102 -25
       187 -80 271 -71 107 -180 181 -307 208 -82 18 -119 18 -200 0z m251 -153 c226
       -106 281 -390 110 -572 -173 -185 -472 -137 -584 94 -36 75 -45 135 -31 208
       27 147 134 261 278 298 63 16 159 4 227 -28z"
                />
                <path
                    d="M1294 841 c-97 -25 -186 -100 -227 -189 -15 -34 -21 -68 -21 -122 -1
       -66 4 -85 32 -142 58 -117 156 -179 284 -179 130 0 233 63 289 176 58 118 38
       257 -50 358 -66 75 -214 122 -307 98z m175 -149 c165 -100 89 -362 -104 -362
       -112 0 -196 84 -196 195 0 161 161 251 300 167z"
                />
                <path
                    d="M2303 1005 c-227 -49 -383 -245 -383 -481 0 -144 50 -255 159 -357
       96 -88 195 -126 332 -127 236 -1 444 180 480 418 30 203 -79 410 -265 502
       -117 58 -206 70 -323 45z m190 -130 c193 -50 311 -245 263 -433 -72 -281 -420
       -370 -615 -157 -64 71 -91 141 -91 240 0 99 27 169 92 241 97 106 219 144 351
       109z"
                />
                <path
                    d="M2313 833 c-105 -36 -188 -120 -214 -218 -17 -61 -6 -182 20 -234 79
       -153 273 -217 427 -141 70 34 125 90 157 160 29 64 29 187 0 252 -67 148 -243
       230 -390 181z m142 -114 c88 -25 145 -99 145 -188 0 -63 -13 -97 -53 -140 -57
       -60 -138 -77 -215 -46 -176 74 -155 331 30 375 46 11 49 11 93 -1z"
                />
                <path
                    d="M3343 1005 c-226 -49 -383 -245 -383 -479 0 -207 111 -370 310 -456
       62 -27 138 -29 425 -13 l150 8 57 110 c32 61 58 113 58 118 0 4 -16 7 -35 7
       -40 0 -41 4 -20 53 26 63 37 167 25 243 -32 203 -187 367 -389 410 -80 17
       -117 17 -198 -1z m229 -142 c114 -45 194 -135 224 -255 37 -142 -19 -283 -150
       -379 l-39 -29 107 0 c97 0 107 -2 104 -17 -3 -17 -21 -18 -223 -17 -269 1
       -303 10 -401 108 -74 75 -105 146 -105 246 -1 114 29 186 108 261 106 103 246
       133 375 82z"
                />
                <path
                    d="M3356 834 c-141 -45 -228 -163 -228 -310 0 -88 28 -158 91 -222 64
       -66 129 -92 227 -92 70 0 89 4 142 30 113 57 176 161 176 290 0 90 -22 147
       -84 214 -80 87 -216 125 -324 90z m191 -140 c58 -33 93 -95 93 -162 0 -64 -13
       -98 -53 -141 -80 -84 -210 -83 -286 5 -40 45 -51 73 -51 131 0 58 32 126 72
       155 75 53 148 57 225 12z"
                />
                <path
                    d="M100 525 l0 -465 218 0 c238 0 300 9 376 54 85 50 129 131 129 241 0
       79 -24 139 -74 186 l-29 27 30 53 c24 44 30 66 30 119 0 82 -23 134 -81 183
       -69 60 -110 67 -371 67 l-228 0 0 -465z m450 341 c51 -21 87 -64 100 -119 16
       -75 -11 -147 -71 -185 l-30 -19 29 -12 c37 -15 87 -67 101 -104 27 -70 -1
       -165 -60 -210 -50 -37 -100 -47 -246 -47 l-133 0 0 354 c0 322 2 355 17 358
       47 9 261 -2 293 -16z"
                />
                <path
                    d="M280 706 l0 -146 108 1 c127 0 168 12 199 58 27 40 31 117 8 161 -26
       50 -66 64 -197 68 l-118 4 0 -146z m195 49 c14 -13 25 -33 25 -45 0 -32 -45
       -72 -78 -68 -26 3 -27 5 -30 71 l-3 67 31 0 c19 0 40 -9 55 -25z"
                />
                <path
                    d="M280 366 l0 -156 123 0 c107 0 128 3 167 23 104 52 107 186 7 261
       -25 18 -45 21 -163 24 l-134 4 0 -156z m224 53 c20 -16 26 -29 26 -59 0 -51
       -35 -80 -96 -80 l-44 0 0 80 0 80 44 0 c29 0 52 -7 70 -21z"
                />
                <path
                    d="M4012 653 c6 -374 10 -405 71 -485 71 -93 187 -134 354 -126 125 6
       203 38 268 110 76 85 78 96 83 491 l4 347 -151 0 -150 0 -3 -321 -3 -321 -24
       -19 c-42 -34 -119 -19 -140 28 -7 16 -11 127 -11 328 l0 305 -151 0 -151 0 4
       -337z m178 -44 c5 -294 7 -305 62 -356 35 -33 76 -45 155 -45 86 0 145 27 177
       82 20 33 21 54 24 310 3 266 7 300 34 284 12 -8 10 -523 -3 -567 -26 -93 -116
       -150 -238 -149 -117 0 -186 38 -225 121 -19 43 -21 66 -24 309 -2 145 -1 270
       2 279 3 8 12 13 19 11 9 -4 13 -72 17 -279z"
                />
                <path
                    d="M4890 525 l0 -465 155 0 155 0 0 465 0 465 -155 0 -155 0 0 -465z
       m180 -1 c0 -347 0 -354 -20 -354 -20 0 -20 7 -20 353 0 195 3 356 6 360 3 3
       12 3 20 0 12 -4 14 -65 14 -359z"
                />
                <path
                    d="M5386 982 c-8 -13 -86 -216 -86 -224 0 -5 56 -8 125 -8 69 0 125 -2
       125 -4 0 -2 -66 -142 -146 -312 -80 -170 -152 -324 -160 -342 l-14 -32 323 0
       323 0 42 113 c23 61 42 115 42 120 0 4 -65 7 -145 7 -81 0 -145 4 -145 9 0 14
       27 73 174 384 75 159 136 290 136 293 0 8 -589 4 -594 -4z m404 -107 c0 -8
       -165 -363 -281 -605 l-26 -55 163 -3 c156 -2 164 -3 164 -22 0 -19 -7 -20
       -195 -20 -107 0 -195 2 -195 4 0 3 25 58 56 123 31 65 72 152 91 193 20 41 64
       135 99 209 35 74 64 138 64 142 0 5 -63 9 -141 9 -108 0 -140 3 -137 13 6 17
       52 22 205 22 79 0 133 -4 133 -10z"
                />
            </g>
        </svg>
    );
};

export default Logo;
